import { render, staticRenderFns } from "./BusinessAnalyticsComponent.vue?vue&type=template&id=0c1fd70c&scoped=true"
import script from "./BusinessAnalyticsComponent.vue?vue&type=script&lang=js"
export * from "./BusinessAnalyticsComponent.vue?vue&type=script&lang=js"
import style0 from "./BusinessAnalyticsComponent.vue?vue&type=style&index=0&id=0c1fd70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fd70c",
  null
  
)

export default component.exports